/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AttachmentTypeForTech {
    Base = '0',
    File = 1,
}
